import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal } from '@mui/material';

import previewBarBackground from '~/assets/images/iphone-white-bg.webp';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

type MobilePreviewBarLayoutProps = PropsWithChildren<{
  isOpen?: boolean;
  onClose?: () => void;
}>;
export const MobilePreviewBarLayout = ({ children, isOpen, onClose }: MobilePreviewBarLayoutProps) => {
  const { t } = useTranslation();

  const styles = useStyles();

  return (
    <Modal
      // Don't remove keepMounted cause for dynamic report there is a requests for get microsite data in PreviewScreen
      // Refactor this
      keepMounted
      open={isOpen}
      onClose={onClose}
      sx={styles.modal}
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
    >
      <Box sx={styles.container}>
        <IconButton onClick={onClose} sx={styles.closeIconWrapper}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>

        <Text variant="h2" sx={styles.title}>
          {t('createQrStep1:previewTitle')}
        </Text>

        <Box sx={styles.phone}>{children}</Box>
      </Box>
    </Modal>
  );
};

const useStyles = () => {
  return {
    container: css`
      width: calc(100dvw - 32px);
      padding: 20px 20px 40px;
      border-radius: 16px;
      background-color: ${COLORS.white};
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    backdrop: css`
      background-color: #c9c8c84d;
      backdrop-filter: blur(3px);
    `,
    modal: css`
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    closeIcon: css`
      color: ${COLORS.textMain};
    `,
    closeIconWrapper: css`
      margin-left: auto;
    `,
    title: css`
      text-align: center;
      margin-bottom: 24px;
    `,
    phone: css`
      background-image: url(${previewBarBackground});
      width: 278px;
      aspect-ratio: 73 / 150;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      overflow: auto;
      display: flex;
      align-items: center;
    `,
  };
};
